import { ChartAPIReturn, EventsConfig } from '@toggle/chart';
import { ChartInsight } from '@toggle/toggle';
import React, { FC, RefObject } from 'react';
import { useTranslation } from 'react-i18next';

import { useInsightsInDomain } from '../../hooks/use-insights-in-domain/useInsightsInDomain';
import { ChartInsightIcon } from './chart-insight-icon/ChartInsightIcon';
import * as S from './Insights.styles';

export interface InsightsProps {
  chartApiRef: RefObject<ChartAPIReturn | null>;
  canvasRef: RefObject<HTMLCanvasElement | null>;
  insights: ChartInsight[];
  eventsConfig: EventsConfig;
  isSimpleChart?: boolean;
  chartWidth?: number;
  chartHeight?: number;
  minIconY?: number;
  minRightOffset?: number;
}

export const Insights: FC<InsightsProps> = ({
  chartApiRef,
  canvasRef,
  insights,
  eventsConfig,
  isSimpleChart,
  chartWidth,
  chartHeight,
  minIconY,
  minRightOffset,
}) => {
  const { t } = useTranslation(['chart']);

  const { insightsInDomain, zoomIntoViewText } = useInsightsInDomain({
    canvasRef,
    eventsConfig,
    chartApiRef,
    insights,
    chartWidth,
    chartHeight,
  });

  return (
    <>
      {insightsInDomain.map((domainEntry, insightsInDomainIndex) => (
        <ChartInsightIcon
          key={insightsInDomainIndex}
          insightIconRight={Math.max(domainEntry.right, minRightOffset ?? 0)}
          insightIconTop={domainEntry.top}
          yOffsetCount={domainEntry.yOffsetCount}
          minIconY={minIconY}
          groupedInsights={domainEntry.groupedInsights}
          isSimpleChart={isSimpleChart}
        />
      ))}

      {zoomIntoViewText && (
        <S.ZoomIntoViewText
          data-testid="zoom-in-required"
          style={{
            top: zoomIntoViewText.y,
            right: zoomIntoViewText.right,
          }}
        >
          {t('chart:zoomInToView')}
        </S.ZoomIntoViewText>
      )}
    </>
  );
};
